import { Telescope } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const TelescopeIcon = createLucideIcon(Telescope);
